module.exports = __webpack_public_path__ + "media/src/images/backgrounds/landing-achievements-banner-7701b6ca09141588b1485c515e3e4f6d.svg";